export function setEncryptionSelectors(w?: Window): void {
    if (!w) {
        return;
    }
    const selectors = [
        '.quantity-input',
        '[data-testid="debit-credit-panel-save-for-next-purchase"]>input[type="checkbox"]',
        '[data-testid="gift-option-form-input-giftMessageText"]',
        '[data-testid="gift-option-form-input-senderName"]',
        '[data-testid="header.menu.search.input"]',
        '[data-testid="shipping-address-edit-address-select"]',
        '#billing-address-address1-field',
        '#billing-address-address2-field',
        '#billing-address-city-field',
        '#billing-address-first-name-field',
        '#billing-address-last-name-field',
        '#billing-address-postal-code-field',
        '#billing-address-state-code-field',
        '#checkout-email-address-input',
        '#checkout-password-input',
        '#checkout-remember-me-button',
        '#contact-email-field',
        '#contact-first-name-field',
        '#contact-last-name-field',
        '#contact-phone-field',
        '#contact-sign-up-emails-field',
        '#order-summary-containerpromo-code-code-field',
        '#promo-code-code-field',
        '#shipping-address-address1-field',
        '#shipping-address-address2-field',
        '#shipping-address-city-field',
        '#shipping-address-first-name-field',
        '#shipping-address-last-name-field',
        '#shipping-address-postal-code-field',
        '#shipping-address-state-code-field',
    ];
    w._uxa = w._uxa || [];
    w._uxa.push(['setEncryptionSelectors', selectors.join(', ')]);
}
